<template>
  <!-- 主子表 -->
  <!-- 父级 行复选框 -->
  <el-checkbox
    :indeterminate="indeterminate"
    :checked="isChecked"
    @change="handleCheckAllChange"
  />
</template>

<script>
export default {
  computed: {
    isChecked() {
      const { childrenListKey = '_details' } = this.params.context
      if (this.params.data._selectedKeys && this.params.data[childrenListKey]) {
        return (
          this.params.data._selectedKeys.length === this.params.data[childrenListKey].length &&
          this.params.data._selected
        )
      }
      return this.params.data._selected // false
    },
    indeterminate() {
      const { _selectedKeys } = this.params.data
      const { childrenListKey = '_details' } = this.params.context
      if (_selectedKeys && this.params.data[childrenListKey]) {
        return (
          !!_selectedKeys.length &&
          _selectedKeys.length !== this.params.data[childrenListKey].length
        )
      }
      return false
    }
  },
  mounted() {
    const { _selected, _selectedKeys } = this.params.data
    if (typeof _selected !== 'boolean') {
      console.error('_selected配置未初始化')
    }
    if (typeof _selectedKeys !== 'object') {
      console.error('_selectedKeys配置未初始化')
    }
  },
  methods: {
    async handleCheckAllChange(e) {
      const { childrenListKey = '_details', childRowKey } = this.params.context
      this.params.data._selected = e
      this.params.node.selected = e
      // 调用子表更新
      if (!this.params.data[childrenListKey]) {
        this.params.data[childrenListKey] = []
      }
      if (
        e &&
        !this.params.data[childrenListKey].length &&
        typeof this.params.context.loadDetail === 'function'
      ) {
        this.params.data[childrenListKey] =
          await this.params.context.loadDetail(this.params.data)
      }
      if (e && this.params.data[childrenListKey]) {
        this.params.data._selectedKeys = this.params.data[childrenListKey].map(
          (item) => {
            return item[childRowKey]
          }
        )
      } else {
        this.params.data._selectedKeys = []
      }
      this.params.api.refreshCells({ force: true })
      const detailNode = this.params.node.detailNode
      detailNode &&
        detailNode.detailGridInfo &&
        detailNode.detailGridInfo.api.refreshCells({ force: true })
      if (detailNode) {
        this.toggleSelectedClass(detailNode, e ? 'add' : 'remove')
      }
    },
    toggleSelectedClass(node, operate) {
      if (!node.detailGridInfo) return

      const parentEl = document.querySelector(`[row-id="${node.detailGridInfo.id}"] .ag-details-row`)
      if (!parentEl) return

      Array.from(parentEl.children).forEach(item => item.classList[operate](...['ag-row-focus', 'ag-row-selected']))
    }
  }
}
</script>
